/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { Grid, Typography, Collapse, Box, Divider, styled } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import { InfoOutlined } from '@mui/icons-material';
import HideInMobile from 'src/_common/quillElements/fragment/HideinMobile';
import { QuillDrawer, RootState } from 'src/_common/models/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import MobileControls from 'src/summarizer/components/MobileControls';
import ShowInMobile from 'src/_common/quillElements/fragment/ShowInMobile';
import MaximizeouticonButton from '@Common/quillElements/button/MaximizeouticonButton';
import { DEVICE_VIEWPORTS } from 'config/constants';
import { MySlider } from 'src/_common/quillElements/slider/MySlider';
import DeleteInputText from '@Common/components/DeleteInputText';
import ControlBar from './ControlBar';
import TypesDialog from './shared/TypesDialog';
import SummaryTypes from './shared/SummaryTypes';
import {
  changeSummaryModeAction,
  clearSummaryDataAction,
  userUploadedFile,
} from '../actions/controlActions';
import { absSliderValues, extSliderValues } from '../mConstants';
import { getOutputKey } from '../handlers/logic';
import { ExtUnionGuard } from '../guards/union';
import { OutputExt } from '../models/store';
import SummaryRatio from './shared/SummaryRatio';
import SummarizerDrawerControlBar from './SummarizerDrawerControlBar';

const useStyles = makeStyles((theme) =>
  createStyles({
    iconButton: {
      padding: '6px',
      '&:hover': {
        backgroundColor: 'inherit',
        // color: theme.palette.primary.main,
      },
    },
    badge: {
      height: '15px',
      fontSize: '10px',
      top: '-6px',
      paddingLeft: '11px',
      paddingRight: '11px',
      left: '22px',
      borderRadius: '0 0 3px 3px',
    },
    extText: {
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '14px',
      [theme.breakpoints.down(375)]: {
        fontSize: '13px',
      },
    },

    quill: {
      margin: '12px 0px',
      '& label': {
        'font-weight': 'bold',
        'font-size': '13px',
        'line-height': '13px',
        color: theme.palette.primary.main,
        // 'margin-right': '10px',
        textAlign: 'left',
        'min-width': '65px',
        'text-transform': 'uppercase',
        display: 'flex',
        'align-items': 'center',
        [theme.breakpoints.down(375)]: {
          fontSize: '12px',
        },
      },
    },
    extSlideoutBtn: {
      display: 'block',
      paddingTop: '0px',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
    },
    sliderWidthForIE: {
      minWidth: '100%',
    },
    disabled: {
      opacity: 0.4,
      cursor: 'none',
      pointerEvents: 'none',
    },
  })
);

const StyledDesktopTitleBar = styled(Grid)`
  && {
    padding: 7px 16px 7px 16px;
    max-height: 63px;
    @media ${DEVICE_VIEWPORTS.xs} {
      display: none;
    }
  }
`;

const StyledSummarizerTitle = styled(Grid)<{ quillDrawer: QuillDrawer | undefined }>`
  && {
    @media ${(props) => props.quillDrawer && '(max-width: 1400px)'},
      ${DEVICE_VIEWPORTS.lg},
      ${DEVICE_VIEWPORTS.md},
      ${DEVICE_VIEWPORTS.sm} {
      display: none;
    }
  }
`;

const wordFliperTextAbs = [
  'Fewest Sentences',
  'Some Sentences',
  'More Sentences',
  'Most Sentences',
];
const typeLabel = {
  abs: 'Paragraph',
  ext: 'Key Sentences',
};

function TopControlBar({ inputRef }: any) {
  const classes = useStyles();
  const [showTypesDialog, setTypesDialog] = useState(false);
  const dispatch = useDispatch();
  const summaryMode = useSelector((state: RootState) => state.smzr.controls.summaryMode);
  const [showQuillSettings, setQuillSettings] = useState(false);
  const absLengthGauge = useSelector((state: RootState) => state.smzr.controls.absLengthGauge);
  const extLengthGauge = useSelector((state: RootState) => state.smzr.controls.extLengthGauge);
  const totalOutputSentences = useSelector((state: RootState) => {
    const outputKey = getOutputKey(summaryMode, absLengthGauge);
    const isExtType = ExtUnionGuard(state.smzr.output[outputKey]);
    return isExtType ? (state.smzr.output[outputKey] as OutputExt).sentenceSequence.length : 0;
  });
  const isKeyboardOpen = useSelector((state: RootState) => state.common.isKeyboardOpen);
  const isFeedbackDrawerOpen = useSelector((state: RootState) => state.common.quillDrawer);
  const mode = useSelector((state: RootState) => state.smzr.controls.summaryMode);
  const selectedKeywords = useSelector((state: RootState) => state.smzr.controls.selectedKeywords);
  const inputText = useSelector((state: RootState) => state.smzr.input.inputPara);
  const quilledInput = useSelector((state: RootState) => state.smzr.output.origText);
  const isQuilling = useSelector((state: RootState) => state.smzr.controls.isQuilling);
  const { isDesktop, isIE, isExtension } = useSelector((state: RootState) => state.common.platform);
  const quillDrawer = useSelector((state: RootState) => state?.common?.quillDrawer);

  if (isKeyboardOpen) {
    return null;
  }

  const toggleQuillSettings = () => {
    setQuillSettings(!showQuillSettings);
  };

  let sliderValue = absLengthGauge * 10;
  let sliderValues = absSliderValues;
  let wordFlipperLabel = wordFliperTextAbs[sliderValue - 1];
  if (summaryMode === 'ext') {
    sliderValue = extLengthGauge;
    wordFlipperLabel = `${sliderValue} Sentence${sliderValue > 1 ? 's' : ''}`;
    if (totalOutputSentences) extSliderValues.max = totalOutputSentences;
    else extSliderValues.max = 20;
    sliderValues = { ...sliderValues, ...extSliderValues };
  }

  const clearSummaryData = () => {
    dispatch(userUploadedFile({ fileName: '', fileType: '' }));
    inputRef.current.innerHTML = '';
    dispatch(clearSummaryDataAction());
  };

  return (
    <>
      <ShowInMobile
        className="extHeader "
        style={{ cursor: 'pointer' }}
        onClick={toggleQuillSettings}
      >
        <Grid container alignItems="center" justifyContent="space-around">
          <Grid container alignItems="center" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
            <Grid item xs={4} sm={4} md={4}>
              <div className={classes.quill}>
                <label> Modes:</label>

                <div className={classes.extText} id="summaryMode">
                  {typeLabel[summaryMode]}
                </div>
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <div className={classes.quill}>
                <label>
                  LENGTH:
                  <MySlider
                    max={sliderValues.max}
                    min={sliderValues.min}
                    value={sliderValue}
                    width={60}
                    hidethumb="true"
                    style={{ pointerEvents: 'none', marginLeft: 4 }}
                  />
                </label>
                <div className={classes.extText}>{wordFlipperLabel}</div>
              </div>
            </Grid>
            <Grid item xs={1} sm={1} md={1}>
              {(inputText || quilledInput) && (
                <DeleteInputText isQuilling={isQuilling} clearInputText={clearSummaryData} />
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={1}>
              <ControlBar />
            </Grid>
          </Grid>
          <Divider style={{ width: '100%' }} />
          <Collapse
            in={showQuillSettings}
            className={`${isIE ? classes.sliderWidthForIE : undefined}`}
          >
            <Grid container alignItems="center" style={{ padding: '10px 0px' }}>
              <Grid item xs={12} sm={12} md={12}>
                <MobileControls />
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
        <MaximizeouticonButton onClick={toggleQuillSettings} />
        <Divider />
      </ShowInMobile>
      <StyledDesktopTitleBar container alignItems="center">
        <StyledSummarizerTitle quillDrawer={quillDrawer} item sm>
          <Grid container alignItems="center">
            {/* <Badge
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              classes={{ badge: classes.badge }}
              color="secondary"
              variant="standard"
              badgeContent="Beta"> */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography style={{ fontWeight: 'bold' }} component="h2" color="textSecondary">
                Summarizer
              </Typography>
              <InfoOutlined
                color="primary"
                fontSize="small"
                onClick={() => setTypesDialog(true)}
                style={{ marginLeft: '2px', cursor: 'pointer' }}
              />
            </div>
            {/* </Badge> */}
          </Grid>
        </StyledSummarizerTitle>
        <HideInMobile>
          <Grid item>
            <Grid container justifyContent="center" direction="row">
              <SummaryTypes
                onClick={() =>
                  dispatch(changeSummaryModeAction(summaryMode === 'abs' ? 'ext' : 'abs'))
                }
                summaryType={summaryMode}
              />
            </Grid>
          </Grid>
        </HideInMobile>

        <Grid item xs>
          <Grid container justifyContent="space-between" style={{ paddingLeft: '14px' }}>
            {mode === 'abs' && (
              <Grid item className={selectedKeywords.length > 0 ? classes.disabled : undefined}>
                <Box>
                  <SummaryRatio
                    values={absSliderValues}
                    currentValue={absLengthGauge * 10}
                    disabled={selectedKeywords.length > 0}
                  />
                </Box>
              </Grid>
            )}
            {mode === 'ext' && (
              <Grid item>
                <Box>
                  <SummaryRatio
                    values={extSliderValues}
                    currentValue={extLengthGauge}
                    step={
                      totalOutputSentences
                        ? Math.ceil(totalOutputSentences / extSliderValues.step)
                        : null
                    }
                  />
                </Box>
              </Grid>
            )}
            <Grid>
              {(inputText || quilledInput) && (
                <DeleteInputText isQuilling={isQuilling} clearInputText={clearSummaryData} />
              )}
            </Grid>
          </Grid>
        </Grid>
        <TypesDialog onClose={() => setTypesDialog(false)} open={showTypesDialog} />
      </StyledDesktopTitleBar>
      {isDesktop && !isExtension && (
        <div style={{ position: isIE ? 'absolute' : 'sticky', top: isIE ? '85px' : '0px' }}>
          <div
            style={{
              position: 'absolute',
              right: '-40px',
              top: '0px',
            }}
          >
            {!isFeedbackDrawerOpen && <SummarizerDrawerControlBar />}
          </div>
        </div>
      )}
    </>
  );
}

export default TopControlBar;
